interface AuthErrorProps {
  title: string
  message: string
  details?: string
}

function AuthError({ title, message, details }: AuthErrorProps) {
  return (
    <div className="card">
      <div className="error-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
      <div className="card-header">
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
      {details && <div className="alert alert-error">{details}</div>}
    </div>
  )
}

export default AuthError
